import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({
  colors,
  borders,
  spacing,
  typography,
}: Theme) => createStyles({
  root: {
    width: '100%',
  },
  radioGroupRoot: {
    width: 'fit-content',
  },
  radio: {
    width: spacing(6),
    height: spacing(6),
    padding: spacing(1),
    marginRight: spacing(1),
    color: colors.controls.options.enabled.icon,
    borderRadius: borders.radius1,
    '&:hover': {
      backgroundColor: colors.controls.options.hovered.hoverArea,
    },
    '&:active': {
      backgroundColor: colors.controls.options.pressed.hoverArea,
    },
    '& svg': {
      width: spacing(3) + 2,
      height: spacing(3) + 2,
    },
  },
  disabled: {
    color: colors.controls.options.disabled.icon,
    '& span': {
      color: colors.controls.options.disabled.text,
    },
  },
  label: {
    marginLeft: 0,
    color: colors.controls.options.enabled.text,

    '& span': {
      ...typography.textRegular,
    },
  },
});

export default styles;
